<template>
<div>
  <div slot="content">
    <el-steps :active="activeStep" finish-status="success" class="mr-b30">
      <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
    </el-steps>
    <div v-show="activeStep === 1">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="info-text" style="font-size: 15px;">* 검색할 프로세스를 선택해주세요. 다중 선택이 가능합니다.</div>
        <div>
          <el-button :disabled="!isNext" size="small" type="primary" v-if="activeStep === 1" @click="nextPage">다음</el-button>
        </div>
      </el-row>
      <hr class="mr-b20" style="margin-top:0px;" /> <!-- el-row + hr로 인해 적용되는 margin-top 제거 -->
      <w-search-process-list ref="searchProcessList" @changeSize="changeSize"></w-search-process-list>
    </div>
    <div v-show="activeStep === 2">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="info-text" style="font-size: 15px;">프로세스를 검색할 장비를 선택해주세요. 다중 선택이 가능합니다.</div>
        </div>
        <div>
          <el-button size="small" @click="prevStep">전 단계</el-button>
          <el-button :disabled="!isSearch" type="primary" size="small" @click="searchProcess">프로세스 검색</el-button>
        </div>
      </el-row>
      <w-common-obj-list ref="commonObjList" type="physical" title="검색 장비 목록" selected-managetype-id="SMS" @change-obj-list="changeObjList" />
    </div>
    <div v-show="activeStep === 3">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="info-text" style="font-size: 15px;">검색된 프로세스 중 중요 프로세스로 등록할 프로세스를 선택해주세요. 다중 선택이 가능합니다.</div>
        <div>
          <el-button size="small" @click="prevStep">전 단계</el-button>
          <el-button size="small" type="primary" @click="applyMajorProc">등록</el-button>
        </div>
      </el-row>
       <el-tree ref="majorTree" class="tree-checkbox" show-checkbox :data="procData" :props="defaultProps" node-key="treeKey" :expand-on-click-node="false" highlight-current :filter-node-method="filterNode">
       </el-tree>
    </div>
  </div>
  <w-duplicate-major-proc-popup ref="duplicateMajorProcPopup" @reload="loadFirst" :saveDataList="saveDataList" :duplicateData="duplicateData"></w-duplicate-major-proc-popup>
</div>
</template>

<script>
import { isEmpty, clone, find, map } from 'lodash';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WSearchProcessList from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/component/SearchProcessList';
import WDuplicateMajorProcPopup from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/DuplicateMajorProcPopup';
import WCommonObjList from '@/components/table/CommonObjList';
import { defaultProps } from '@/constants/tree';
import TreeFilter from '@/mixins/tree/filter';

export default {
  name: 'WProcessBatchRegistView',
  mixins: [TreeFilter],
  components: {
    WSearchProcessList,
    WDuplicateMajorProcPopup,
    WCommonObjList,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      saveDataList: null,
      duplicateData: [],
      defaultProps,
      physicalTreeData: [],
      procData: null,
      checkNodeList: [],
      isNext: false,
      isSearch: false,
      isApplyProc: false,
      selectPhysicalNode: null,
      activeStep: 1,
      stepTitles: ['프로세스 선택', '검색 장비 선택', '중요 프로세스 등록'],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.loadTreeData();
        if (this.activeStep !== 1) {
          this.loadFirst();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadTreeData() {
      if (this.activeTab === this.$options.name) {
        this.$refs.searchProcessList.loadTree();
      }
    },
    changeObjList(objList) {
      const size = isEmpty(objList) ? 0 : objList.length;
      if (size > 0) {
        this.isSearch = true;
      } else {
        this.isSearch = false;
      }
    },
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    nextPage() {
      this.activeStep = this.activeStep + 1;
    },
    changeSize(size) {
      if (size > 0) {
        this.isNext = true;
      } else {
        this.isNext = false;
      }
    },
    loadFirst() {
      this.activeStep = 1;
      this.isNext = false;
      this.isSearch = false;
      this.loadTreeData();
      this.$refs.searchProcessList.loadData();
      this.$refs.commonObjList.initData();
      this.$refs.majorTree.setCheckedKeys([]);
    },
    applyMajorProc() {
      const majorProcList = this.$refs.majorTree.getFilteredCheckedNodes();
      const checkedProc = [];
      const me = this;
      majorProcList.forEach((node) => {
        if (node.type === 'PROC') {
          checkedProc.push(node);
        }
      });
      this.saveDataList = checkedProc;
      ServerSettingAPI.insertMajorProcess(checkedProc).then((response) => {
        if (response.data.success) {
          // this.loadData();
          this.loadFirst();
          this.$message({
            message: '중요 프로세스를 등록했습니다.',
            type: 'success',
          });
        } else if (response.data.message === 'DUPLICATE_PROCID') {
          const duplicateData = response.data.data;
          const duplicateCount = duplicateData.length;
          this.$confirm(`동일한 프로세스가 ${duplicateCount}건 등록되어 있습니다. (저장버튼을 누르면 기 등록된 프로세스를 제외하고 저장됩니다.)`, 'Warning', {
            confirmButtonText: '이름변경',
            cancelButtonText: '저장',
            type: 'info',
          }).then(() => {
            me.duplicateData = response.data.data;
            this.$refs.duplicateMajorProcPopup.open();
          }).catch(() => {
            const exceptList = [];
            checkedProc.forEach((node) => {
              const selectedData = find(this.duplicateData, (item) => item.processId !== node.processId);
              exceptList.push(selectedData);
            });
            ServerSettingAPI.insertMajorProcess(exceptList).then((result) => {
              if (result.data.success) {
                this.$message({
                  message: '중요 프로세스를 등록했습니다.',
                  type: 'success',
                });
              }
            });
          });
        }
      });
    },
    searchProcess() {
      const objList = this.$refs.commonObjList.getSelectedObjList();
      const serverIds = map(objList, 'serverId');
      const searchProcList = this.$refs.searchProcessList.procChangeList;

      ServerSettingAPI.getServerProcessTree({ searchProcList, serverIds }).then((response) => {
        if (response.data.success) {
          this.procData = clone(response.data.data);
          this.activeStep = this.activeStep + 1;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/ProcessBatchRegistView.vue